import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { getJobPositions, getConsents, getDeletionRequests, getJobEducationLevels, getJobEmploymentTypes, getJobWorkplaceTypes, getJobSalaryPeriods, getSkills, getLanguages } from '@sameta/shared';

@Injectable()
export class JobPositionsTranslateLoader implements TranslateLoader {

  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    // Load the existing app-specific translations
    const appTranslations$ = this.http.get(`./assets/i18n/${lang}.json`);

    return appTranslations$.pipe(
      map((appTranslations: any) => {
        // Get shared job positions for this language
        const jobTranslations = getJobPositions(lang as 'sk' | 'en' | 'cz');
        const deletionRequestTranslations = getDeletionRequests(lang as 'sk' | 'en' | 'cz');
        const educationLevelsTranslations = getJobEducationLevels(lang as 'sk' | 'en' | 'cz');
        const employmentTypesTranslations = getJobEmploymentTypes(lang as 'sk' | 'en' | 'cz');
        const workplaceTypesTranslations = getJobWorkplaceTypes(lang as 'sk' | 'en' | 'cz');
        const salaryPeriodsTranslations = getJobSalaryPeriods(lang as 'sk' | 'en' | 'cz');
        const skillsTranslations = getSkills(lang as 'sk' | 'en' | 'cz');
        const languagesTranslations = getLanguages(lang as 'sk' | 'en' | 'cz');

        // Merge app translations with shared translations
        return {
          ...appTranslations,
          jobCategories: jobTranslations.jobCategories,
          jobPositions: jobTranslations.jobPositions,
          jobEducationLevels: educationLevelsTranslations.jobEducationLevels,
          jobEmploymentTypes: employmentTypesTranslations.jobEmploymentTypes,
          jobWorkplaceTypes: workplaceTypesTranslations.jobWorkplaceTypes,
          jobSalaryPeriods: salaryPeriodsTranslations.jobSalaryPeriods,
          skillCategories: skillsTranslations.skillCategories,
          skills: skillsTranslations.skills,
          languages: languagesTranslations.languages,
          modals: {
            ...appTranslations.modals,
            ...deletionRequestTranslations.modals
          },
          deletionRequests: deletionRequestTranslations
        };
      })
    );
  }
}
